import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import scrollIntoView from 'scroll-into-view';
import { FormattedMessage } from 'react-intl';

import style from './ExpandableContent.scss';

import { ReadMoreButton } from './ReadMoreButton';

const readMoreDefaultMessage = (
    <FormattedMessage id="global.ExpandableContent.readMore" defaultMessage="continue reading" />
);
const readLessDefaultMessage = (
    <FormattedMessage id="global.ExpandableContent.readLess" defaultMessage="read less" />
);

class ExpandableContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: props.initiallyExpanded,
            hasReadMore: props.collapseHeight === 0,
        };

        this.ref = {};

        this.toggleReadMore = this.toggleReadMore.bind(this);
    }
    componentDidMount() {
        this.setReadMore();
    }

    componentWillReceiveProps() {
        this.setReadMore();
    }

    getDescriptionHeight() {
        return this.ref.description.offsetHeight;
    }

    setReadMore() {
        // Check if the actual height of the description is greater than the collapseHeight.
        // If it is we want to show the "CONTINUE READING" text link.
        if (this.getDescriptionHeight() > this.props.collapseHeight) {
            this.setState({ hasReadMore: true });
        }
    }

    toggleReadMore(event) {
        const { isExpanded } = this.state;
        event.preventDefault();

        if (this.props.onToggleReadMore) {
            this.props.onToggleReadMore(isExpanded);
        }
        // When collapsing return the scroll to the top of the component.
        if (isExpanded) {
            scrollIntoView(this.ref.top, {
                time: 1000,
            });
        }

        this.setState({ isExpanded: !isExpanded });
    }

    render() {
        const {
            collapseHeight,
            className,
            buttonClassName,
            onExpandEnd,
            readMoreMessage,
            readLessMessage,
            dataTn,
        } = this.props;

        const { isExpanded, hasReadMore } = this.state;

        const wrapperClassName = classnames(this.props.wrapperClassName, style.wrapper);
        const contentClassname = classnames(style.content, className, {
            [style.expanded]: isExpanded,
        });
        const contentStyles = {
            maxHeight: isExpanded ? this.getDescriptionHeight() : collapseHeight,
        };

        const readMoreButtonProps = {
            className: buttonClassName,
            onClick: this.toggleReadMore,
            readMoreMessage,
            readLessMessage,
            isExpanded,
        };

        return (
            <div className={wrapperClassName}>
                <span
                    ref={el => {
                        this.ref.top = el;
                    }}
                />

                <div
                    className={contentClassname}
                    style={contentStyles}
                    onTransitionEnd={onExpandEnd}
                    data-tn={dataTn}
                >
                    <div
                        ref={el => {
                            this.ref.description = el;
                        }}
                    >
                        {this.props.children}
                    </div>
                </div>

                {hasReadMore && <ReadMoreButton {...readMoreButtonProps} />}
            </div>
        );
    }
}

ExpandableContent.propTypes = {
    children: PropTypes.node,

    initiallyExpanded: PropTypes.bool,
    wrapperClassName: PropTypes.string,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,

    collapseHeight: PropTypes.number,
    onExpandEnd: PropTypes.func,
    onToggleReadMore: PropTypes.func,

    readMoreMessage: PropTypes.node,
    readLessMessage: PropTypes.node,

    dataTn: PropTypes.string,
};

ExpandableContent.defaultProps = {
    initiallyExpanded: false,
    collapseHeight: 120,
    readMoreMessage: readMoreDefaultMessage,
    readLessMessage: readLessDefaultMessage,
};

export { ExpandableContent };
